import { useMutation, useQuery } from '@tanstack/react-query';
import { useXAgentClient } from '@shuwen/wenlv-web-activity-library';
import {
  // getData,
   getLandmark, getMajorEvents,
  getAgentData,
  getAllRoute,
  getLocalJson,
} from './api';
import { getPoetry } from './poetry';
import { useStore } from '@/store';

/**
 * 获取data
 * */
// export const useQueryGetData = () => {
//   const { deviceInfo } = useXAgentClient();
//   // console.log('useQueryGetData', deviceInfo);
//   const { activityId = 'test', deviceId } = deviceInfo || {};
//   return useQuery({
//     queryKey: ['getData'],
//     queryFn: () => getData({ activityId, deviceId }),
//     staleTime: Infinity,
//   });
// };
/**
 * 获取d首页
 * */
export const useQueryLandmark = () => {
  const { deviceInfo } = useXAgentClient();
  // console.log('useQueryGetData', deviceInfo);
  const { activityId = 'test', deviceId } = deviceInfo || {};
  return useQuery({
    queryKey: ['getLandmark'],
    queryFn: () => getLandmark({ activityId, deviceId },deviceInfo?.exhibitionConfigInfo?.isLocalData),
    staleTime: Infinity,
  });
};
/**
 * 获取大事件
* */
 export const useQueryEvents = () => {
   const { deviceInfo } = useXAgentClient();
   // console.log('useQueryGetData', deviceInfo);
   const { activityId = 'test', deviceId } = deviceInfo || {};
   return useQuery({
     queryKey: ['getMajorEvents'],
     queryFn: () => getMajorEvents({ activityId, deviceId }),
     staleTime: Infinity,
   });
 };
/**
 * 获取诗词地标
* */
export const useQueryPoetry = () => {
  const { deviceInfo } = useXAgentClient();
  // console.log('useQueryGetData', deviceInfo);
  const { activityId = 'test', deviceId } = deviceInfo || {};
  return useQuery({
    queryKey: ['getPoetry'],
    queryFn: () => getPoetry(
      { activityId, deviceId },
      (progress) => useStore.getState().setPoetryProgress(progress),
    ),
    staleTime: Infinity,
  });
};

export const useQueryGetPlaceJson = () => {
  return useQuery({
    queryKey: ['getLocalPlaceJson'],
    queryFn: () => getLocalJson('json/place.json'),
    staleTime: Infinity,
  });
};


/**
 * 获取路线数据
 * */
export const useQueryGetAllRouteData = () => {
  // const { deviceInfo } = useXAgentClient();
  // console.log('useQueryGetData', deviceInfo);
  // const { activityId = 'test', deviceId } = deviceInfo || {};
  return useQuery({
    queryKey: ['getAllRoute'],
    queryFn: () => getAllRoute(),
    staleTime: Infinity,
  });
};

// 获取agent数据
export const useMutationGetAgentData = () => {
  return useMutation({
    mutationKey: ['getAgentData'],
    mutationFn: (query: string) => getAgentData(query),
  });
};


